// src/config/page.types.ts

export enum PageType {
	Home = "HOME",

	DataCollectionMonitor = "DATA_COLLECTION_MONITOR",
	DataCollectionImport = "DATA_COLLECTION_IMPORT",
	DataCollectionConfiguration = "DATA_COLLECTION_CONFIGURATION",
	DataCollectionConfigurationOperationalUnits = "DATA_COLLECTION_CONFIGURATION_OPERATIONAL_UNITS",
	DataCollectionConfigurationOperationalUnitsAddUnit = "DATA_COLLECTION_CONFIGURATION_OPERATIONAL_UNITS_ADD_UNIT",
	DataCollectionConfigurationOperationalUnitsDetail = "DATA_COLLECTION_CONFIGURATION_OPERATIONAL_UNITS_DETAIL",

	ResultsOverview = "RESULTS_OVERVIEW",
	ResultsDetails = "RESULTS_DETAILS",
	ResultsReport = "RESULTS_REPORT",

	ResultsDashboardInsights = "RESULTS_DASHBOARD_INSIGHTS",
	ResultsDashboardInsightsDetail = "RESULTS_DASHBOARD_INSIGHTS_DETAIL",

	ResultsTransport = "RESULTS_TRANSPORT",
	ResultsTransportGreenRouter = "RESULTS_TRANSPORT_GREENROUTER",
	ResultsTransportGreenRouterEntities = "RESULTS_TRANSPORT_GREENROUTER_ENTITIES",
	ResultsTransportGreenRouterDetail = "RESULTS_TRANSPORT_GREENROUTER_DETAIL",
	ResultsTransportGreenRouterEntityDetail = "RESULTS_TRANSPORT_GREENROUTER_ENTITY_DETAIL",
	ResultsTransportThirdParty = "RESULTS_TRANSPORT_THIRD_PARTY",
	ResultsTransportThirdPartyDetail = "RESULTS_TRANSPORT_THIRD_PARTY_DETAIL",

	ResultsOperationalUnits = "RESULTS_OPERATIONAL_UNITS",
	ResultsOperationalUnitsGreenRouter = "RESULTS_OPERATIONAL_UNITS_GREENROUTER",
	ResultsOperationalUnitsGreenRouterDetail = "RESULTS_OPERATIONAL_UNITS_GREENROUTER_DETAIL",
	ResultsOperationalUnitsThirdParty = "RESULTS_OPERATIONAL_UNITS_THIRD_PARTY",
	ResultsOperationalUnitsThirdPartyDetail = "RESULTS_OPERATIONAL_UNITS_THIRD_PARTY_DETAIL",

	WhatIfSimulation = "WHAT_IF_SIMULATION",
	WhatIfCarbonBudget = "WHAT_IF_CARBON_BUDGET",
	WhatIfRootCause = "WHAT_IF_ROOT_CAUSE",
	WhatIfRootCauseResults = "WHAT_IF_ROOT_CAUSE_RESULTS",

	AdditionalServicesDocumentation = "ADDITIONAL_SERVICES_DOCUMENTATION",
	AdditionalServicesTourWizard = "ADDITIONAL_SERVICES_TOUR_WIZARD",
	AdditionalServicesCarbonSnap = "ADDITIONAL_SERVICES_CARBON_SNAP",
	AdditionalServicesCarbonSnapResults = "ADDITIONAL_SERVICES_CARBON_SNAP_RESULTS",

	SettingsAdmin = "SETTINGS_ADMIN",
	SettingsAuthApi = "SETTINGS_AUTH_API",
	SettingsPersonalised = "SETTINGS_PERSONALISED",

	Account = "ACCOUNT",
}
